var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.125 12.5C3.12593 11.8094 3.28484 11.1281 3.58958 10.5084V10.5084C5.31396 7.19455 8.76499 5.14185 12.5 5.20836C16.235 5.14185 19.686 7.19455 21.4104 10.5084V10.5084C22.0299 11.7639 22.0299 13.2362 21.4104 14.4917V14.4917C19.686 17.8055 16.235 19.8582 12.5 19.7917C8.76499 19.8582 5.31396 17.8055 3.58958 14.4917V14.4917C3.28484 13.8719 3.12593 13.1907 3.125 12.5Z",
    stroke: "#1D1E14",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 12.5C15.625 14.2259 14.2259 15.625 12.5 15.625C10.7741 15.625 9.375 14.2259 9.375 12.5C9.375 10.7741 10.7741 9.375 12.5 9.375",
    stroke: "#1D1E14",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eyeOpen.36823b843d857675c2891e7ebf679c52.svg";
export { ForwardRef as ReactComponent };